import React from "react"
import PropTypes from "prop-types"

// from https://github.com/coreyward/gatsby-plugin-segment-analytics/, 
// but we didn't need the whole package
// MIT license

// disable a few a11y warns that ESLint is warning about but are 
// actually fine in the larger component context for this component 
/*eslint-disable jsx-a11y/anchor-has-content*/
/*eslint-disable jsx-a11y/click-events-have-key-events*/
/*eslint-disable jsx-a11y/interactive-supports-focus*/

const OutboundLink = ({ eventName, categoryName, ...props }) => {
    return (
        <a
            {...props}
            role="link"
            onClick={(e) => {
                if (typeof props.onClick === `function`) {
                    props.onClick(e)
                }
                let redirect = true
                if (
                    e.button !== 0 ||
                    e.altKey ||
                    e.ctrlKey ||
                    e.metaKey ||
                    e.shiftKey ||
                    e.defaultPrevented
                ) {
                    redirect = false
                }
                if (props.target && props.target.toLowerCase() !== `_self`) {
                    redirect = false
                }
                if (typeof window !== "undefined" && window.analytics) {
                    window.analytics.track(
                        eventName || "Click",
                        {
                            category: categoryName || `Outbound Link`,
                            label: props.href,
                        },
                        null,
                        () => {
                            if (redirect) {
                                document.location = props.href
                            }
                        }
                    )
                } else {
                    if (redirect) {
                        document.location = props.href
                    }
                }

                return false
            }}
        />
    )
}

OutboundLink.propTypes = {
    href: PropTypes.string,
    target: PropTypes.string,
    onClick: PropTypes.func,
    eventName: PropTypes.string,
    categoryName: PropTypes.string,
}

export default OutboundLink;